import { logoutOnServer } from 'api/auth';
import { LOGIN_PATH } from 'constants/routes';
import { removeToken } from 'utils/accessToken';
import { setAuthToken } from 'utils/axios';
import logger from 'utils/logger';

import { loginAsAction, logoutAsAction, unauthorizedAction } from './index';

export const logoutThunk =
  ({ getSignInPath } = {}) =>
  async () => {
    try {
      try {
        await logoutOnServer();
      } catch (err) {
        logger.error(err);
      } finally {
        removeToken();
        setAuthToken();

        window.location.replace(getSignInPath ? getSignInPath() : LOGIN_PATH);
      }

      /**
       * old log out flow with no hard reload
       *
       * reason of removing soft redirect: https://app.asana.com/0/0/1200924364809913/f
       */
      // batch(() => {
      //   dispatch(resetUserStateAction());
      //   dispatch(logoutSuccess());
      // });
    } catch (e) {
      throw new Error(e);
    }
  };

export const loginAsThunk = (userId, accId) => async (dispatch) => {
  dispatch(loginAsAction({ userId, accId }));
};

export const logoutAsThunk = () => async (dispatch) => {
  dispatch(logoutAsAction());
};

export const unauthorizedThunk = (value) => async (dispatch) => {
  dispatch(unauthorizedAction(value));
};
